<p-toast></p-toast>
<p-confirmDialog #cd appendTo="body">
  <ng-template pTemplate="footer">
    <p-button [style]="{ 'border-radius.px': 6, 'margin-right.px': 20 }" *ngIf="cancelButton" severity="danger"
      icon="pi pi-times" label="No" (click)="cd.reject()"></p-button>
    <p-button [style]="{ 'border-radius.px': 6, 'margin-right.px': 20 }" *ngIf="cancelButton" severity="success"
      icon="pi pi-check" label="Si" (click)="cd.accept()"></p-button>
    <p-button [style]="{ 'border-radius.px': 6, 'margin-right.px': 20 }" *ngIf="!cancelButton" severity="success"
      icon="pi pi-check" label="OK" (click)="cd.accept()"></p-button>
  </ng-template>
</p-confirmDialog>

<app-spinner-loading 
  *ngIf="mode === 'default'" 
  [loading]="loading">
</app-spinner-loading>

<app-spinner-loading-pdf 
  *ngIf="mode === 'pdf'" 
  [loading]="loading">
</app-spinner-loading-pdf>
<app-spinner-loading-excel 
  *ngIf="mode === 'excel'" 
  [loading]="loading">
</app-spinner-loading-excel>